import { Typography } from '@sanlam-glacier/app-common/components';
import { useLocation, useNavigate } from 'react-router-dom';
import styles from './top-navigation-item.module.scss';
import clsx from 'clsx';
import { NavMenuItemType } from 'modules/app/types/navigation-menu.type';

export const TopNavigationItem = ({ entry }: { entry: NavMenuItemType }) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const isCurrent = pathname === `/${entry.route}`;

  return (
    <button
      className={clsx(isCurrent ? styles.currentPageButton : styles.normalButton, styles.navButton)}
      onClick={() => navigate(entry.route)}
    >
      <Typography color={Typography.COLOR.INHERIT}>{entry.displayName}</Typography>
    </button>
  );
};
